import { render } from "./XianxianHerbsList.vue?vue&type=template&id=1d896940&scoped=true"
import script from "./XianxianHerbsList.vue?vue&type=script&lang=js"
export * from "./XianxianHerbsList.vue?vue&type=script&lang=js"

import "./XianxianHerbsList.vue?vue&type=style&index=0&id=1d896940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.106.2_@swc+core@1.3.96_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d896940"]])

export default __exports__